import { NavLink } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import styles from './Sidebar.module.css'
import { NAV_ITEMS } from './navItems'
import { useAuth } from '../../auth/AuthContext'
import { Avatar } from '../ui/Avatar'
import { BrandMark } from './BrandMark'
import { settingsApi } from '../../api/settings.api'
import { useChatUnreadTotal } from '../../modules/chat/useChatUnreadTotal'

export function Sidebar() {
  const { me, hasAnyPermission } = useAuth()
  const { data: settings } = useQuery({
    queryKey: ['settings', 'general'],
    queryFn: async () => (await settingsApi.get()).data,
    staleTime: 60_000,
  })
  const chatUnread = useChatUnreadTotal(hasAnyPermission(['chat.use']))

  return (
    <aside className={styles.sidebar}>
      <div className={styles.brand}>
        <BrandMark logoUrl={settings?.logoUrl} className={styles.brandMark} />
        <span className={styles.brandLabel}>{settings?.appName ?? 'NTL Dashboard'}</span>
      </div>

      <nav className={styles.nav}>
        {NAV_ITEMS.filter((item) => !item.requiredPermissions || hasAnyPermission(item.requiredPermissions)).map(
          (item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) => [styles.navItem, isActive ? styles.navItemActive : ''].join(' ')}
            >
              <span className={styles.navIconWrap}>
                <span className={styles.navIcon}>{item.icon}</span>
                {item.to === '/chat' && chatUnread > 0 ? (
                  <span className={styles.navBadge}>{chatUnread > 99 ? '99+' : chatUnread}</span>
                ) : null}
              </span>
              <span className={styles.navLabel}>{item.label}</span>
            </NavLink>
          ),
        )}
      </nav>

      {me ? (
        <div className={styles.footer}>
          <NavLink to="/profile" className={styles.navItem} style={{ padding: 0 }}>
            <Avatar name={me.user.displayName} imageUrl={me.user.avatarUrl} status={me.user.status} />
            <span className={styles.navLabel} style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {me.user.displayName}
            </span>
          </NavLink>
        </div>
      ) : null}
    </aside>
  )
}
